<template>
	<div ref="reqs-section" class="requirements-section">
		<div class="title">{{ $t('main.details-tabs.requirements') }}</div>
		<div class="content">
			<div v-if="minimum.length > 0">
				<span>{{ $t('main.minimum') }}</span>
				<table>
					<tr v-for="(req, $index) in minimum" :key="$index">
						<td>
							<div>{{ req[0] }}</div>
						</td>
						<td>
							<div>{{ req[1] }}</div>
						</td>
					</tr>
				</table>
			</div>
			<div v-if="recommended.length > 0" :class="{ spacing: minimum.length > 0 }">
				<span>{{ $t('main.recommended') }}</span>
				<table>
					<tr v-for="(req, $index) in recommended" :key="$index">
						<td>
							<div>{{ req[0] }}</div>
						</td>
						<td>
							<div>{{ req[1] }}</div>
						</td>
					</tr>
				</table>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'GameDetailsRequirementsSection',
	components: {},
	props: {
		minimum: {
			type: Array,
			default: () => [],
		},
		recommended: {
			type: Array,
			default: () => [],
		},
	},
	data() {
		return {};
	},
	computed: {},
	mounted() {
		this.$emit('setRef', 'requirements', this.$refs['reqs-section']);
	},
	methods: {},
};
</script>

<style lang="less" scoped>
.requirements-section {
	height: 100%;
	margin-bottom: 40px;
	padding: 0 20px;
	user-select: none;
	width: 100%;
	.title {
		color: white;
		font-size: 20px;
		height: 40px;
		letter-spacing: -0.4px;
	}
	.content {
		background-color: #27292c;
		border: 1px solid rgba(255, 255, 255, 0.1);
		border-radius: 5px;
		box-shadow: 0 0 1px 0 #000000;
		color: #7e7e7f;
		font-size: 14px;
		letter-spacing: -0.28px;
		line-height: 26px;
		margin: auto;
		padding: 24px 23px 24px 20px;
		width: auto;
		.spacing {
			margin-top: 35px;
		}
		span {
			color: white;
			font-size: 20px;
			letter-spacing: -0.4px;
		}
		table {
			margin-top: 20px;
			tr {
				height: 40px;
				td {
					vertical-align: top;
					&:first-child {
						white-space: nowrap;
						div {
							margin-right: 15px;
						}
					}
					&:last-child {
						div {
							color: #dcdcdc;
						}
					}
				}
			}
		}
	}
}

@media (min-width: 768px) {
	.requirements-section {
		margin-bottom: 50px;
		.content {
			padding: 50px 51px 47px 49px;
			.spacing {
				margin-top: 50px;
			}
		}
	}
}

@media (min-width: 1024px) {
	.requirements-section {
		.title {
			font-size: 16px;
			letter-spacing: -0.32px;
			margin: 40px auto 0;
			padding-top: 5px;
			width: 770px;
		}
		.content {
			display: flex;
			font-size: 12px;
			letter-spacing: -0.24px;
			line-height: 18px;
			padding: 40px 36px;
			width: 770px;
			> div:nth-child(2) {
				margin-left: 100px;
			}
			.spacing {
				margin: 0;
			}
			span {
				font-size: 16px;
				letter-spacing: -0.32px;
			}
			table {
				margin-top: 40px;
				tr {
					td {
						display: flex;
						height: 30px;
						&:last-child {
							margin-bottom: 15px;
						}
					}
				}
			}
		}
	}
}

@media (min-width: 1280px) {
	.requirements-section {
		.title {
			width: 960px;
		}
		.content {
			width: 960px;
			> div:nth-child(2) {
				margin-left: 150px;
			}
		}
	}
}

@media (min-width: 1440px) {
	.requirements-section {
		display: flex;
		margin: 50px auto 0;
		padding: 0;
		width: 1080px;
		.title {
			color: white;
			font-size: 20px;
			letter-spacing: -0.4px;
			margin: 0;
			width: 250px;
		}
		.content {
			flex: 1;
			font-size: 14px;
			letter-spacing: -0.28px;
			line-height: 24px;
			margin: 0 0 0 20px;
			padding: 50px;
			> div:nth-child(2) {
				margin-left: 100px;
			}
			span {
				font-size: 20px;
				letter-spacing: -0.4px;
			}
			table {
				margin-top: 30px;
			}
		}
	}
}

@media (min-width: 1600px) {
	.requirements-section {
		margin: 80px auto 0;
		width: 1200px;
		.title {
			width: 270px;
		}
		.content {
			padding: 49px 53px 47px 50px;
			> div:nth-child(2) {
				margin-left: 150px;
			}
		}
	}
}

@media (min-width: 1920px) {
	.requirements-section {
		width: 1440px;
		.title {
			width: 340px;
		}
	}
}
</style>
